import { render, staticRenderFns } from "./EditTypologySize.vue?vue&type=template&id=71c50544&scoped=true&"
import script from "./EditTypologySize.vue?vue&type=script&lang=js&"
export * from "./EditTypologySize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c50544",
  null
  
)

export default component.exports